import { Card, ActionIcon, Flex, Group, Tooltip, Text } from "@mantine/core";
import { Calendar } from "react-big-calendar";
import { IconArrowsMaximize, IconArrowsMinimize, IconCirclePlus, IconCloudUpload, IconFileDownload, IconRefresh } from "@tabler/icons-react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { localizer } from "./calendarioConfig";
import EncabezadoAgendaVista from "./encabezadoAgendaVista";
import ModaltareaCV from "../../Tareas/controladorVista/modalTareaCV";
import { estadoInicialTarea } from "../../Tareas/interfaces";
import type { IAgendaVistaProps } from "../interfaces";
import FiltrosAgendaCV from "../controladorVista/filtrosAgendaCV";
import EventoPersonalizado from "./eventoPersonalizadoVista";
import { useRef } from "react";
import ModalErroresCargaMasiva from "../../Tareas/vista/modalErroresCargaMasiva";

const AgendaVista: React.FunctionComponent<IAgendaVistaProps> = ({
    abrirModal,
    abrirModalTarea,
    eventosTareas,
    fecha,
    manejarCambioFecha,
    filtrosAbiertos,
    manejarHabilitarFiltros,
    vista,
    manejarCambioVista,
    formatosCalendario,
    manejarSeleccionEspacio,
    manejarSeleccionEvento,
    entidadTarea,
    setEntidadTarea,
    descargarPlantilla,
    listaTecnicos,
    pantallaCompleta,
    manejarCargaMasivaTareas,
    manejarPantallaCompleta,
    filtroAgenda,
    setFiltroAgenda,
    visualizacion,
    refrescarConsulta,
    abrirModalErrores,
    setAbrirModalErrores,
    datosRespuestaCarga,
    entidadesRegistro,
}) => {

    const refAgenda = useRef<HTMLDivElement | null>(null);

    const alternarPantallaCompleta = () => {
        manejarPantallaCompleta();
    };

    return (
        <div
            style={{
                position: pantallaCompleta ? "fixed" : "relative",
                top: pantallaCompleta ? 0 : undefined,
                left: pantallaCompleta ? 0 : undefined,
                width: pantallaCompleta ? "100vw" : "100%",
                height: pantallaCompleta ? "100vh" : "100%",
                background: "#fff",
                padding: pantallaCompleta ? '1rem' : '0rem',
                zIndex: pantallaCompleta ? 100000 : "auto",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                // height: '100%',         // Toma el 100% del alto del Card en App.tsx
                // display: 'flex',
                // flexDirection: 'column',
                // overflow: 'hidden'
            }}
            ref={refAgenda}>
            <Group justify="space-between" pb={0} m={0} style={{ width: "100%", alignItems: "center", flexShrink: 0 }}>
                <Group><Text fw={700} size="lg">Agenda</Text></Group>
                <Group gap={4}>
                     <Tooltip zIndex={10000} label="Refresh" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
                        <ActionIcon
                            variant="subtle"
                            color="primary"
                            radius="xl"
                            onClick={() => refrescarConsulta()}
                        >
                            <IconRefresh size={16} />
                        </ActionIcon>
                    </Tooltip>
                    <Tooltip zIndex={10000} label="Pantalla Completa" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
                        <ActionIcon
                            variant="subtle"
                            color="primary"
                            radius="xl"
                            onClick={alternarPantallaCompleta}
                        >
                            {pantallaCompleta ? <IconArrowsMinimize size={16} /> : <IconArrowsMaximize size={16} />}
                        </ActionIcon>
                    </Tooltip>
                    <Tooltip zIndex={100000} label="Descargar Plantilla" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
                        <ActionIcon
                            variant="subtle"
                            color="primary"
                            radius="xl"
                            onClick={descargarPlantilla}
                        >
                            <IconFileDownload size={16} />
                        </ActionIcon>
                    </Tooltip>
                    <Tooltip zIndex={100000} label="Carga Masiva (Preventivos)" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
                        <ActionIcon
                            variant="subtle"
                            color="primary"
                            radius="xl"
                            onClick={manejarCargaMasivaTareas}
                        >
                            <IconCloudUpload size={16} />
                        </ActionIcon>
                    </Tooltip>
                    <Tooltip zIndex={100000} label="Agregar Tarea" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
                        <ActionIcon
                            variant="subtle"
                            color="primary"
                            radius="xl"
                            size={25}
                            onClick={() => abrirModalTarea(true, estadoInicialTarea)}
                        >
                            <IconCirclePlus size={16} />
                        </ActionIcon>
                    </Tooltip>
                </Group>
            </Group>

            <Flex
                style={{ flex: 1, minHeight: 0, overflow: "hidden" }}
            // style={{
            //     height: "calc(100vh - 100px)",
            //     position: "relative",
            //     overflow: "hidden",
            // }}
            >
                <div
                    style={{
                        width: filtrosAbiertos ? 280 : 0,
                        transition: "width 0.3s ease",
                        overflow: "hidden",
                        flexShrink: 0,
                    }}
                >
                    {filtrosAbiertos && (
                        <Card radius="lg" padding="md" style={{ height: "100%" }}>
                            <FiltrosAgendaCV
                                filtroAgenda={filtroAgenda}
                                setFiltroAgenda={setFiltroAgenda}
                            />
                        </Card>
                    )}
                </div>
                <div>
                    <ModaltareaCV
                        consultarTareas={() => { }}
                        abrirModalTarea={abrirModalTarea}
                        estadoModal={abrirModal}
                        entidadTarea={entidadTarea}
                        setEntidadTarea={setEntidadTarea}
                        esEmergencia={false}
                        visualizacion={visualizacion}
                        entidadesRegistro={entidadesRegistro}
                    />
                </div>
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        minHeight: 0,
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            overflow: "hidden",
                            position: "relative",
                            height: '100%',
                            width: '100%',
                        }}
                    >
                        <Calendar
                            localizer={localizer}
                            events={eventosTareas}
                            startAccessor="start"
                            endAccessor="end"
                            selectable
                            popup
                            onSelectSlot={manejarSeleccionEspacio}
                            onSelectEvent={manejarSeleccionEvento}
                            views={["month", "week", "day", "agenda"]}
                            resources={listaTecnicos}
                            resourceIdAccessor="Id"
                            resourceTitleAccessor="NombreCompleto"
                            resourceAccessor="AsignadaA"
                            date={fecha}
                            view={vista}
                            onNavigate={(newDate) => {
                                const d = new Date(newDate as any);
                                manejarCambioFecha(d)
                            }}
                            onView={(v) => {
                                manejarCambioVista(v)
                            }}
                            components={{
                                event: (props) => <EventoPersonalizado {...props} view={vista} />,
                                agenda: {
                                    event: (props) => <EventoPersonalizado {...props} view="agenda" />,
                                },
                                toolbar: (props) => (
                                    <EncabezadoAgendaVista
                                        {...props}
                                        manejarHabilitarFiltros={manejarHabilitarFiltros}
                                        habilitarFiltros={filtrosAbiertos}
                                        date={props.date}
                                        label={props.label}
                                        localizer={localizer}
                                        onNavigate={props.onNavigate}
                                    />
                                ),
                            }}
                            scrollToTime={new Date(2025, 1, 1, 8, 0)}
                            style={{
                                flex: 1,
                                height: '100%',
                                width: '100%',
                                marginBottom: '10rem',
                            }}
                            messages={{
                                next: "Sig.",
                                previous: "Ant.",
                                today: "Hoy",
                                month: "Mes",
                                week: "Semana",
                                day: "Día",
                                agenda: "Agenda",
                                date: "Fecha",
                                time: "Hora",
                                event: "Tarea",
                                allDay: "Todo el día",
                                noEventsInRange: "No hay tareas en este rango.",
                                showMore: (total) => `+ Ver más (${total})`,
                            }}
                            formats={formatosCalendario}
                        />
                    </div>
                </div>
            </Flex>
            <ModalErroresCargaMasiva
                abrir={abrirModalErrores}
                onClose={() => setAbrirModalErrores(false)}
                rechazadas={datosRespuestaCarga.Rechazadas}
                totales={{
                    guardadas: datosRespuestaCarga.TareasGuardadas,
                    rechazadas: datosRespuestaCarga.TareasRechazadas
                }}
            />
        </div>
    );
};

export default AgendaVista;